import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { TenantsService } from '../../core/services/tenants.service';
import { companyConfigService } from '../services/company-config.service';
import { AuthService } from '../services/auth-service.service';
import { Router } from '@angular/router';

export const customInterceptorInterceptor: HttpInterceptorFn = (req, next) => {
  const cookieService = inject(CookieService);
  const TenantsSer = inject(TenantsService);
  const companyConfig = inject(companyConfigService);
  const authService = inject(AuthService);
  const router = inject(Router);

  const tenantId = TenantsSer.getTenantFromSubdomain(); // Get the tenant ID from the service
  let clientapikey = '';
  switch (tenantId) {
    case 'NS':
      clientapikey = 'NS123'; // Set the client API key for NS tenant
      break;

    default:
      break;
  }
  let token = cookieService.get('B2Btoken'); // use the injected service
  // if (token == null || token == '') {
  //   token = JSON.parse(JSON.stringify(companyConfig.getGuestToken())).guesttoken;
  // }
  const authReq = req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
      'x-client-apikey': clientapikey,
    },
  });

  // Pass the modified request to the next handler
  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      console.error('HTTP error intercepted:', error);
      if (error.status === 401) {
        // Clear B2B authentication cookie
        cookieService.delete('B2Btoken', '/');
        // Trigger AuthService logout to clean up IndexedDB & state
        authService.logout().then(() => {
          // Redirect to the login page
          router.navigate(['/login']);
        });
      }
      return throwError(() => error);
    })
  );
};
